import Image, { ImageProps } from "next/image";
import React from "react";
import logoImg from "images/logo.jpg";

const Logo = (props: Omit<ImageProps, "src">) => {
  return <Image src={logoImg} alt="logo" {...props} />;
};

export default Logo;
